import React, { useState, useEffect } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import styled from 'styled-components';
import { navDelay, loaderDelay } from '@utils';
import { usePrefersReducedMotion } from '@hooks';

const StyledHeroSection = styled.section`
  ${({ theme }) => theme.mixins.flexCenter};
  flex-direction: column;
  align-items: flex-start;
  min-height: 100vh;
  height: 100vh;
  padding: 0;

  @media (max-height: 700px) and (min-width: 700px), (max-width: 360px) {
    height: auto;
    padding-top: var(--nav-height);
  }

  h1 {
    margin: 0 0 30px 4px;
    color: var(--green);
    font-family: var(--font-mono);
    font-size: clamp(var(--fz-sm), 5vw, var(--fz-md));
    font-weight: 400;

    @media (max-width: 480px) {
      margin: 0 0 20px 2px;
    }
  }

  h3 {
    margin-top: 5px;
    color: var(--slate);
    line-height: 0.9;
  }

  p {
    margin: 20px 0 0;
    max-width: 540px;
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    margin-top: 50px;
  }
`;

const Hero = () => {
  const [isMounted, setIsMounted] = useState(false);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    const timeout = setTimeout(() => setIsMounted(true), navDelay);
    return () => clearTimeout(timeout);
  }, []);

  const one = <h1>Its Gabriel with a y so its</h1>;
  const two = <h2 className="big-heading">Gabryel.</h2>;
  const three = (
    <h3 className="big-heading">I like building and scaling backend + AI/ML stuff :)</h3>
  );
  const four = (
    <>
      <p>
        I'm a final-year CS student / software engineer. I love tech. Think I found out when my
        pre-frontal cortex fully developed. (And when I deleted instagram).
        <br></br>
        <br></br>
        Its fun designing, building and deploying impactful features like ML-powered tools running
        on stable backend infrastructure, serving real users at scale. I love my users, I love when
        superusers love my stuff.
        <br></br>
        <br></br>
        Most recently built a CI/CD observability and auto-remediation system for global payment
        authorizations infra at{' '}
        <a href="https://www.visa.com/" target="_blank" rel="noreferrer">
          Visa
        </a>
        , and before that a Kafka event-driven KYC workflow service at{' '}
        <a href="https://www.binance.com/" target="_blank" rel="noreferrer">
          Binance
        </a>
        .
      </p>
    </>
  );
  const five = (
    <a className="email-link" href="/gabryel_resume.pdf" target="_blank" rel="noreferrer">
      My Resume
    </a>
  );

  const items = [one, two, three, four, five];

  return (
    <StyledHeroSection>
      {prefersReducedMotion ? (
        <>
          {items.map((item, i) => (
            <div key={i}>{item}</div>
          ))}
        </>
      ) : (
        <TransitionGroup component={null}>
          {isMounted &&
            items.map((item, i) => (
              <CSSTransition key={i} classNames="fadeup" timeout={loaderDelay}>
                <div style={{ transitionDelay: `${i + 1}00ms` }}>{item}</div>
              </CSSTransition>
            ))}
        </TransitionGroup>
      )}
    </StyledHeroSection>
  );
};

export default Hero;
